import formatIso from './formatIso';

export default function normalizeRep(r = {}) {
  const rawCf = r.do_not_show_on_cf ?? r.doNotShowOnCf;
  const do_not_show_on_cf =
    rawCf === true || rawCf === 1 || rawCf === "1" || String(rawCf).toLowerCase() === "true";

  /** List API uses `acct_type` (e.g. S, SM); fall back to user_type for older payloads */
  const rawAcct = r.acct_type ?? r.acctType ?? r.user_type ?? r.userType ?? r.usertype;
  const acct_type = rawAcct != null && rawAcct !== "" ? String(rawAcct).trim() : "";
  const acctUpper = acct_type.toUpperCase();
  const is_sales_rep_manager =
    acctUpper === "SM" || acct_type === "Sales Rep Manager";

  return {
    id: r.id,
    do_not_show_on_cf,
    acct_type,
    is_sales_rep_manager,
    name: `${r.firstname || ''} ${r.lastname || ''}`.trim(),
    email: r.email || '',
    phone: r.phone || r.phone_number || '',
    title: r.title || '',
    state: r.state?.statename || r.state || '',
    county: r.county?.countyname || r.county || '',
    selectedLocations: (Array.isArray(r.selected_locations) ? r.selected_locations : []).map((s) => ({
      stateid: s.state_id || s.stateid || s.id || null,
      state_name: s.state_name || s.statename || s.name || '',
      counties: Array.isArray(s.counties) ? s.counties.map((c) => ({ id: c.county_id || c.countyid || c.id, name: c.countyname || c.name || c.county_name || '' })) : [],
    })),
    stateid: r.state?.id || r.stateid || null,
    countyid: r.county?.id || r.countyid || null,
    created: formatIso(r.created) || "",
    is_active: typeof r.is_active === "boolean" ? r.is_active : !!r.active,
    rep_image: r.rep_image,
    firstname: r.firstname,
    lastname: r.lastname,
  };
}
